import { Component, Inject } from "@angular/core";
import { IdleService } from "./utils/shared-services/idle.service";
import { NavigationEnd, Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { IdleWarningDialogComponent } from "./utils/shared-components/idle-warning-dialog.component";
import { BrowserStorage } from "./utils/shared-services/browser-storage.service";
import { filter } from "rxjs";

@Component({
    selector: "app-root",
    template: `     <router-outlet></router-outlet>
                `,
    standalone: false
})

export class AppRootComponent {

    private dialogRef?: MatDialogRef<IdleWarningDialogComponent>;

    constructor(@Inject(IdleService) private idleService: IdleService,
        @Inject(Router) private router: Router,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage,
    ) {
    }

    ngOnInit() {

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                const hasToken = this.browserStorage.getSessionstorage('userInfo', null);

                if (hasToken) {
                    this.idleService.startWatching();
                } else {
                    this.idleService.stop();
                }
            });

        this.idleService.onIdleStart$.subscribe(() => {
            this.dialogRef = this.dialog.open(IdleWarningDialogComponent, {
                width: '350px',
                disableClose: true,
                data: { countdown: 60 } // initial value (grace period = 60s)
            });

            this.dialogRef.afterClosed().subscribe((stayLoggedIn) => {
                if (stayLoggedIn) {
                    this.idleService.reset();
                } else {
                    this.router.navigate(['/login']);
                }
            });
        });

        this.idleService.onTimeoutWarning$.subscribe((c) => {
            if (this.dialogRef) {
                this.dialogRef.componentInstance.updateCountdown(c);
            }
        });

        this.idleService.onTimeout$.subscribe(() => {
            if (this.dialogRef) {
                this.dialogRef.close(false); // pretend "Logout" was clicked for auto logout
            }
            this.logout();
        });
    }

    private logout() {
        this.idleService.stop();
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/login']);
    }

}
